<template>
  <div class="admin-categories">
    <header-title title="Mesas QR"></header-title>

    <div class="category-btn">
      <v-btn
        dense
        outlined
        @click="openTableDialog('addTable')"
        :style="adminNavigationBackTheme"
      >
        + Nuevo QR
      </v-btn>
    </div>

    <v-container fluid class="pl-0 pr-0">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-text-field
            dense
            outlined
            v-model="search"
            label="Buscar QR"
            class="select-box"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select
            dense
            outlined
            class="select-box"
            v-model="zoneSelected"
            :items="zoneTablesQR"
            item-text="name"
            item-value="id"
            label="Zonas"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select
            dense
            outlined
            class="select-box"
            v-model="activeSelected"
            :items="activeOptions"
            item-text="label"
            item-value="value"
            label="Activo"
          ></v-select>
        </v-col>
        <v-col cols="12" justify="center" sm="6" md="3" lg="2">
          <v-btn
            dense
            outlined
            @click="resetFilters"
            :style="adminResetFiltersTheme"
          >
            Borrar Filtros
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="QRs"
          class="elevation-1 payments-table"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
          no-data-text="No se han encontrado resultados !"
        >
          <template v-slot:[`item.zone_id`]="{ item }">
            <div style="display:flex;">
              {{ getZoneName(item.zone_id) }}
            </div>
          </template>
          <template v-slot:[`item.active`]="{ item }">
            <div style="display:flex;">
              <v-switch
                v-model="item.active"
                @change="markOneQRAsActive($event, item)"
              ></v-switch>
            </div>
          </template>
          <template v-slot:[`item.editAction`]="{ item }">
            <v-icon small class="mr-2" @click="openTableDialog(item.id)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <TableQRDialog ref="tableQrDialog"></TableQRDialog>
  </div>
</template>

<script>
import TableQRDialog from "../../../components/admin/qr/TableQRDialog";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { TablesQRTableHeader } from "@/utils/tableHeaderconstants";
import { qrZoneCollection } from "@/collections/qrZone";
import { qrCollection, updateQR } from "@/collections/qrs";

// eslint-disable-next-line no-unused-vars
let fromRoute = undefined;
export default {
  name: "tables-qr",
  components: {
    TableQRDialog,
    HeaderTitle
  },
  data() {
    return {
      qrCollection: [],
      zoneTablesQR: [],
      search: "",
      activeSelected: "",
      zoneSelected: "",
      headers: [...TablesQRTableHeader],
      activeOptions: [
        {
          label: "Si",
          value: true
        },
        {
          label: "No",
          value: false
        }
      ]
    };
  },
  firestore() {
    return {
      qrCollection: qrCollection,
      zoneTablesQR: qrZoneCollection
    };
  },
  computed: {
    QRs() {
      if (
        this.search !== "" ||
        this.activeSelected !== "" ||
        this.zoneSelected !== ""
      ) {
        let search =
          this.activeSelected !== "" && this.search === ""
            ? this.qrCollection
            : this.qrCollection.filter(qr => {
                return qr.table
                  .toLowerCase()
                  .includes(this.search.toLowerCase());
              });

        if (this.zoneSelected !== "") {
          search = search.filter(qr => this.zoneSelected === qr.zone_id);
        }

        return this.activeSelected !== ""
          ? search.filter(qr => this.activeSelected === qr.active)
          : search;
      }

      return this.qrCollection;
    }
  },
  mounted() {
    setTimeout(() => {}, 2000);
  },
  methods: {
    getZoneName(zoneId) {
      let zone = this.zoneTablesQR.find(x => zoneId === x.id);
      return zone ? zone.name : "";
    },
    resetFilters() {
      this.activeSelected = "";
      this.search = "";
      this.zoneSelected = "";
    },
    async markOneQRAsActive(value, qr) {
      try {
        await updateQR(qr.id, { active: value });
      } catch (error) {
        this.setlogError(
          "update_QR",
          "Obtained error message in markOneQRAsActive()",
          error.stack,
          this.$options.name
        );
      }
    },
    openTableDialog(itemId) {
      this.$refs.tableQrDialog.open(itemId);
    }
  },
  beforeRouteEnter(to, from, next) {
    fromRoute = from;
    next();
  }
};
</script>

<style>
@media screen and (max-width: 767px) {
  .tabs-stage .header-table .header-name,
  .tabs-stage .gfg .geeks-name {
    width: 190px !important;
  }
}
</style>
